export default "__VITE_ASSET__jRbUKHVU__"